import React from 'react'
import GradientText from '../Navbar/reactbits/TextAnimations/GradientText/GradientText'
import useScreenWidth from '../../Hooks/useScreenWidth'


export default function Logo({ alwaysShowText = false }) {
    const isMobile = useScreenWidth() < 768;

    return (
        <>
            <div className='logo' >
                <img src='/logo.png?v=20260603-redirect-fix' alt='Devzona logo' loading='eager' fetchpriority='high' decoding='async' />
                {/* <h3>devzona</h3> */}
                {(!isMobile || alwaysShowText) &&
                    <GradientText
                        colors={["#19D4F2", "#12A8F5", "#096FE8", "#3679e6ff"]}
                        animationSpeed={10}
                        showBorder={false}
                        className="custom-class"
                    >
                        DevZona
                    </GradientText>
                }
            </div>
        </>
    )
}
